'use client';
import { InternalLink } from '../../../../../components/Clickables/InternalLink/InternalLink';
import { useAnalytics } from '@domain/analytics/AnalyticsContext';
import { trackEvent } from '@domain/analytics/trackEvent';

export interface HomePageFeatureSectionLinkProps {
  linkText: string;
  linkRoute: string;
  eventName?: string;
}

export const HomePageFeatureSectionLink = ({
  linkRoute,
  linkText,
  eventName = '',
}: HomePageFeatureSectionLinkProps) => {
  const { currentPage } = useAnalytics();

  const handleLinkClick = ({ featureName }: { featureName: string }): void => {
    trackEvent({
      name: 'mykiss_cta_button_clicked',
      properties: {
        source: featureName,
        type: 'read-more',
        page: currentPage,
      },
    });
  };

  return (
    <InternalLink
      onClick={() => handleLinkClick({ featureName: eventName })}
      to={linkRoute}
      variant="textPrimaryDarkBg"
    >
      {linkText}
    </InternalLink>
  );
};
